import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\CreateImportController::__invoke
* @see app/Http/Controllers/Import/CreateImportController.php
* @route '/api/import'
*/
const CreateImportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateImportController.url(options),
    method: 'post',
})

CreateImportController.definition = {
    methods: ["post"],
    url: '/api/import',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Import\CreateImportController::__invoke
* @see app/Http/Controllers/Import/CreateImportController.php
* @route '/api/import'
*/
CreateImportController.url = (options?: RouteQueryOptions) => {
    return CreateImportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\CreateImportController::__invoke
* @see app/Http/Controllers/Import/CreateImportController.php
* @route '/api/import'
*/
CreateImportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateImportController.url(options),
    method: 'post',
})

export default CreateImportController